var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvGenerateInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095582"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624128",
    width: 40,
    height: 40,
    rx: 4,
    fill: "#3397F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10C11 8.89543 11.8954 8 13 8H23L30 15V30C30 31.1046 29.1046 32 28 32H13C11.8954 32 11 31.1046 11 30V10ZM27 14L23 10V14H27ZM24.3438 21.2812L24.7344 19.8359H23.1753C23.1061 19.3859 22.967 18.9849 22.7578 18.6328C22.7206 18.5684 22.681 18.5059 22.6392 18.4453H24.3438L24.7422 17H17.4531L17.0078 18.6953H19.0547C19.5443 18.6953 19.9375 18.7786 20.2344 18.9453C20.5312 19.112 20.7474 19.3438 20.8828 19.6406C20.9121 19.7037 20.9382 19.7688 20.9611 19.8359H17.3984L17 21.2812H20.9998C20.9641 21.4038 20.9173 21.521 20.8594 21.6328C20.7135 21.9245 20.4922 22.1562 20.1953 22.3281C19.9036 22.4948 19.5312 22.5781 19.0781 22.5781H17.2188L17.2266 23.8281L21.0781 28.375H23.4609V28.2656L19.9688 24.1016C20.75 23.9974 21.3802 23.7891 21.8594 23.4766C22.3385 23.1641 22.6849 22.7604 22.8984 22.2656C23.03 21.9648 23.122 21.6367 23.1745 21.2812H24.3438Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvGenerateInvoice);
export default __webpack_public_path__ + "static/media/Inv Generate Invoice.2f729262a5794b2975c15e1d1169c63f.svg";
export { ForwardRef as ReactComponent };